import React from "react";
import Container from "react-bootstrap/Container";
import {
  FaTruck,
  FaShoppingCart,
  FaHeart,
  FaUser,
  FaChevronDown,
  FaSearch,
  FaMapMarkerAlt,
  FaTimes
} from "react-icons/fa";
import logo from "../../Asset/Cakerestrologo.png";
import "./Header.css";
import { useNavigate, Link } from "react-router-dom";
import { HiOutlineMenuAlt1 } from "react-icons/hi";
import { isLoggedIn, getCurrentUser, logout } from "../../services/AuthService";
import { getTotalItemsCount } from "../../services/CartService";
import { GetAllProduct, slugify } from "../../services/ProductService";

export const menuItems = [
  {
    label: "Birthday",
    image: "/images/ClassicBlackForestCake.jpg",
    submenu: [
      { label: "Birthday Cakes", href: "/birthday-cakes" },
      { label: "Kids Birthday Cakes", href: "/kids-birthday-cakes" },
      { label: "Birthday Cupcakes", href: "/birthday-cupcakes" },
    ],
  },
  {
    label: "Anniversary",
    image: "/images/AnniversaryCake.jpg",
    submenu: [
      { label: "Anniversary Cakes", href: "/anniversary-cakes" },
      { label: "Young Couple Cakes", href: "/couple-cakes" },
      { label: "Anniversary Cupcakes", href: "/anniversary-cupcakes" },
    ],
  },
  {
    label: "PhotoCakes",
    image: "/images/BirthdayMomentsPhotoCake.webp",
    submenu: [{ label: "Photo Cakes", href: "/photo-cakes" },
    { label: "Kids photo Cakes", href: "/kids-photo-cakes" },
    { label: "photo Cupcakes", href: "/photo-cupcakes" },

    ],
  },
  {
    label: "Flowers",
    image: "/images/ClassicBlackForestCake.jpg", // Replace with realistic flower mock if possible
    submenu: [
      { label: "All Flowers", href: "/flowers" },
      { label: "Valentine Flowers", href: "/valentine-flowers" },
      { label: "Birthday Flowers", href: "/birthday-flowers" },
      { label: "Anniversary Flowers", href: "/anniversary-flowers" }
    ],
  },
  // {
  //   label: "Cakes",
  //   image: "/images/ChocolateTruffleCake.jpg",
  //   submenu: [
  //     {
  //       label: "Cake Types",
  //       submenu: [
  //         { label: "Designer Cakes", href: "/designer-cakes" },
  //         { label: "Photo Cakes", href: "/photo-cakes" },
  //         { label: "Theme Cakes", href: "/theme-cakes" },
  //         { label: "Kids Cakes", href: "/kids-cakes" }
  //       ]
  //     },
  //     {
  //       label: "Cake Flavours",
  //       submenu: [
  //         { label: "Chocolate Cake", href: "/chocolate-cakes" },
  //         { label: "Butterscotch Cake", href: "/butterscotch-cakes" },
  //         { label: "Red Velvet Cake", href: "/red-velvet-cakes" },
  //         { label: "Pineapple Cake", href: "/pineapple-cakes" },
  //         { label: "Black Forest Cake", href: "/black-forest-cakes" }
  //       ]
  //     }
  //   ]
  // },
  {
    label: "Cake Types",
    image: "/images/RedVelvetValentinesCake.jpg",
    submenu: [{ label: "Designer Cakes", href: "/designer-cakes" },
    { label: "Theme Cakes", href: "/theme-cakes" },
    { label: "Kids Cakes", href: "/kids-cakes" }
    ],
  },
  {
    label: "Cake Flavours",
    image: "/images/RedVelvetValentinesCake.jpg",
    submenu: [{ label: "Chocolate Cake", href: "/chocolate-cakes" },
    { label: "Butterscotch Cake", href: "/butterscotch-cakes" },
    { label: "Red Velvet Cake", href: "/red-velvet-cakes" },
    { label: "Pineapple Cake", href: "/pineapple-cakes" },
    { label: "Black Forest Cake", href: "/black-forest-cakes" }
    ],
  },
  {
    label: "Cake Combos",
    image: "/images/RedVelvetValentinesCake.jpg",
    submenu: [{ label: "Cake with Flowers", href: "/cakes-flower-combo" },
    { label: "Cake with Teddy", href: "/cakes-teddy-combo" },
    { label: "Cake with Chocolates", href: "/cakes-chocolate-combo" }
    ],
  },
  {
    label: "Occasions",
    image: "/images/RedVelvetValentinesCake.jpg",
    submenu: [
      { label: "Holi Cake", href: "/holi-cakes", mrp: "999", discountPrice: "499" },
      { label: "Republic Day Cake", href: "/republic-day-cakes", mrp: "899", discountPrice: "499" },
      { label: "Valentines Day Cake", href: "/valentine-day-cakes", mrp: "1099", discountPrice: "499" },
      { label: "Rakhi", href: "/rakhi", mrp: "799", discountPrice: "399" },
      { label: "Bhai Dooj Cake", href: "/bhai-dooj-cakes", mrp: "899", discountPrice: "499" },
      { label: "Dussehra Cake", href: "/dussehra-cakes", mrp: "899", discountPrice: "499" },
      { label: "Diwali Cake", href: "/diwali-cakes", mrp: "999", discountPrice: "499" },
      { label: "Christmas Cake", href: "/christmas-cakes", mrp: "999", discountPrice: "499" }
    ],
  },
  {
    label: "Relations",
    image: "/images/HeartShapeChocoTruffleCakeWithFondantRoses.jpg",
    submenu: [
      { label: "Cakes for Kids", href: "/cakes-for-kids" },
      { label: "Cakes for Girlfriend", href: "/cakes-for-girlfriend" },
      { label: "Cakes for Boyfriend", href: "/cakes-for-boyfriend" },
      { label: "Cakes for Wife", href: "/cakes-for-wife" },
      { label: "Cakes for Mother", href: "/cakes-for-mother" },
      { label: "Cakes for Father", href: "/cakes-for-father" },
      { label: "Cakes for Husband", href: "/cakes-for-husband" },
      { label: "Cakes for Sister", href: "/cakes-for-sister" },
      { label: "Cakes for Brother", href: "/cakes-for-brother" },
      { label: "Cakes for Daughter", href: "/cakes-for-daughter" },
      { label: "Cakes for Son", href: "/cakes-for-son" },
      { label: "Cakes for Friend", href: "/cakes-for-friend" },
      { label: "Womens Day Cake", href: "/cakes/womens-day-cakes" },
      { label: "Cakes for Grandmother", href: "/cakes-for-grand-mother" },
      { label: "Cakes for Grandfather", href: "/cakes-for-grand-father" },
      { label: "Mothers Day Cake", href: "/cakes/mothers-day-cakes" },
      { label: "Fathers Day Cake", href: "/cakes/fathers-day-cakes" },
    ],
  },
  {
    label: "Locations",
    image: "/images/ClassicBlackForestCake.jpg",
    submenu: [
      { label: "Chandigarh", href: "/cakes/chandigarh" },
      { label: "Panchkula", href: "/cakes/panchkula" },
      { label: "Mohali", href: "/cakes/mohali" },
      { label: "Zirakpur", href: "/cakes/zirakpur" },
      { label: "Delhi", href: "/cakes/delhi" },
      { label: "Gurgaon", href: "/cakes/gurgaon" },
      { label: "Bangalore", href: "/cakes/bangalore" },
      { label: "Pune", href: "/cakes/pune" },
      { label: "Gujarat", href: "/cakes/gujarat" },
      { label: "Uttar Pradesh", href: "/cakes/uttar-pradesh" },
    ],
  },
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [isScrolled, setIsScrolled] = React.useState(false);
  const [openMobileItem, setOpenMobileItem] = React.useState(null);
  const [isLocationPopupOpen, setIsLocationPopupOpen] = React.useState(false);
  const [isSearchOpen, setIsSearchOpen] = React.useState(false);
  const [cartCount, setCartCount] = React.useState(getTotalItemsCount());
  const [user, setUser] = React.useState(getCurrentUser());
  const [searchQuery, setSearchQuery] = React.useState('');
  const [searchResults, setSearchResults] = React.useState([]);
  const [allProducts, setAllProducts] = React.useState([]);
  const searchRef = React.useRef(null);
  const navigate = useNavigate();

  React.useEffect(() => {
    GetAllProduct().then(setAllProducts).catch(() => {});
  }, []);

  React.useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setSearchResults([]);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSearchChange = (e) => {
    const q = e.target.value;
    setSearchQuery(q);
    if (q.trim().length < 2) {
      setSearchResults([]);
      return;
    }
    const lower = q.toLowerCase();
    const results = allProducts.filter(p =>
      p.name.toLowerCase().includes(lower) ||
      p.category?.toLowerCase().includes(lower)
    ).slice(0, 8);
    setSearchResults(results);
  };

  const handleSearchSelect = (product) => {
    setSearchQuery('');
    setSearchResults([]);
    navigate(`/product/${slugify(product.name)}`);
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter' && searchResults.length > 0) {
      handleSearchSelect(searchResults[0]);
    }
  };

  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 150) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    const handleCartUpdate = (e) => {
      setCartCount(e.detail.count);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("cartUpdated", handleCartUpdate);

    // Check for user login on every render (or more robustly via events)
    setUser(getCurrentUser());

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("cartUpdated", handleCartUpdate);
    };
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    if (value) {
      navigate(value);
    }
  };

  const toggleMobileItem = (index) => {
    setOpenMobileItem(openMobileItem === index ? null : index);
  };

  return (
    <header className={`sticky-header ${isScrolled ? "scrolled" : ""}`}>

      {/* TOP STRIP */}
      <div className="top-strip">
        <div className="top-strip-content">
          <span>Cake Restro presents a premium collection of eggless &amp; customized cakes, carefully crafted with the finest ingredients and rich flavours like Chocolate, Butterscotch, Red Velvet, Pineapple and more — thoughtfully made to make every celebration elegant and truly special. Enjoy complimentary delivery on selected orders, safe &amp; secure payments, FSSAI certified quality, and a 100% freshness promise — Order now and experience a truly luxurious dessert indulgence.FREE DELIVERY!!! Enjoy ₹0 shipping with our free delivery time slots</span>
        </div>
      </div>

      {/* MAIN HEADER */}
      <Container fluid className="main-header">
        <div className="main-row">

          {/* Mobile Menu Icon */}
          <div className="mobile-menu-btn" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <HiOutlineMenuAlt1 />
          </div>

          {/* Logo */}
          <Link to="/" className="logo-container">
            <img src={logo} alt="Brand Logo" className="logo" />
          </Link>



          {/* Search */}
          <div className="search-box desktop-only" style={{ position: 'relative' }} ref={searchRef}>
            <div className="search-input-wrap">
              <input
                type="text"
                placeholder="Search cakes, flowers, gifts..."
                value={searchQuery}
                onChange={handleSearchChange}
                onKeyDown={handleSearchKeyDown}
              />
              <FaSearch className="search-icon" />
            </div>
            {searchResults.length > 0 && (
              <div className="search-results-dropdown">
                {searchResults.map((p, i) => (
                  <div key={i} className="search-result-item" onClick={() => handleSearchSelect(p)}>
                    <img src={p.image} alt={p.name} className="search-result-img" />
                    <div className="search-result-info">
                      <span className="search-result-name">{p.name}</span>
                      <span className="search-result-price">₹{p.price}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Icons - Simplified on mobile */}
          <div className="header-icons">
            <div className="search-toggle-mobile mobile-only" onClick={() => setIsSearchOpen(true)}>
              <FaSearch />
            </div>
            <div className="desktop-only"><FaTruck /> <span>Same Day</span></div>
            <div className="cart-icon desktop-only"><FaHeart /></div>
            <div className="cart-icon desktop-only" onClick={() => navigate('/cart')} style={{ cursor: 'pointer', position: 'relative' }}>
              <FaShoppingCart />
              {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
            </div>

            {isLoggedIn() ? (
              <div className="user-icon-logged">
                <FaUser />
                <span className="user-name">Hi {user?.username}</span>
                <Link to="/my-orders" className="my-orders-link">My Orders</Link>
                <button onClick={logout} className="logout-inline-btn">Logout</button>
              </div>
            ) : (
              <div className="user-icon">
                <button onClick={() => navigate('/login')} className="header-login-btn">
                  <FaUser /> <span>Login</span>
                </button>
              </div>
            )}

          </div>

        </div>
      </Container>

      {/* SECOND ROW NAVIGATION (Desktop only) */}
      <Container fluid className="secondary-header desktop-only">
        <nav className="desktop-nav">
          <ul className="menu secondary-menu">
            {menuItems.map((item, index) => (
              <li key={index} className="nav-item">
                <span className="nav-item-label">
                  {item.label} <FaChevronDown style={{ marginLeft: "4px", fontSize: "10px", marginTop: "2px" }} />
                </span>
                {item.submenu && (
                  <div className="dropdown dropdown-mega position-absolute">
                    <div className="dropdown-content d-flex">
                      <div className="dropdown-links flex-grow-1 p-3">
                        {item.label === 'Cakes' ? (
                          <div className="multi-lvl-wrapper d-flex flex-wrap gap-4">
                            {item.submenu.map((subItem, idx) => (
                              <div key={idx} className="mega-col">
                                <h6 style={{ color: '#000', marginBottom: '10px', fontWeight: 'bold' }}>{subItem.label}</h6>
                                <ul className="list-unstyled mb-0">
                                  {subItem.submenu.map((subLink, sidx) => (
                                    <li key={sidx}><Link to={subLink.href}>{subLink.label}</Link></li>
                                  ))}
                                </ul>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <ul className="list-unstyled">
                            {item.submenu.map((sub, subIndex) => (
                              <li key={subIndex}>
                                <Link to={sub.href}>{sub.label}</Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                      {item.image && (
                        <div className="dropdown-image-wrap p-3">
                          <img src={item.image} alt={item.label} style={{ width: '200px', borderRadius: '8px', objectFit: 'cover' }} />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </Container>

      {/* LOCATION POPUP MODAL */}
      {isLocationPopupOpen && (
        <div className="location-modal-overlay">
          <div className="location-modal-content">
            <div className="location-modal-close" onClick={() => setIsLocationPopupOpen(false)}>
              <FaTimes />
            </div>
            <div className="location-modal-header">
              <FaMapMarkerAlt className="location-modal-icon" />
              <h4>Let's Personalize Your Experience!</h4>
            </div>
            <p className="location-modal-subtitle">Find the perfect gifts for you or your loved ones - it's like magic!</p>

            <div className="location-modal-body">
              <div className="location-input-wrap">
                <input type="text" placeholder="Enter Receiver's pincode, location, area" />
              </div>
              <button className="location-continue-btn" onClick={() => setIsLocationPopupOpen(false)}>
                Continue Shopping
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MOBILE SEARCH POPUP */}
      {isSearchOpen && (
        <div className="search-popup-overlay">
          <div className="search-popup-content">
            <div className="search-popup-header">
              <div className="search-input-container">
                <FaSearch className="search-input-icon" />
                <input 
                  type="text" 
                  placeholder="Search for cakes, flowers, gifts..." 
                  value={searchQuery}
                  onChange={handleSearchChange}
                  onKeyDown={(e) => { handleSearchKeyDown(e); if (e.key === 'Enter') setIsSearchOpen(false); }}
                  autoFocus 
                  className="mobile-search-input"
                />
              </div>
              <button className="search-popup-close-btn" onClick={() => setIsSearchOpen(false)}>
                <FaTimes />
              </button>
            </div>
            
            <div className="search-popup-body">
              {searchResults.length > 0 ? (
                <div className="mobile-search-results">
                  {searchResults.map((p, i) => (
                    <div key={i} className="search-result-item" onClick={() => { handleSearchSelect(p); setIsSearchOpen(false); }}>
                      <img src={p.image} alt={p.name} className="search-result-img" />
                      <div className="search-result-info">
                        <span className="search-result-name">{p.name}</span>
                        <span className="search-result-price">₹{p.price}</span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="suggested-section">
                  <h5>Suggested for you</h5>
                  <div className="suggestion-chips">
                     {[
                      { label: "Birthday", href: "/birthday-cakes" },
                      { label: "Anniversary", href: "/anniversary-cakes" },
                      { label: "Photo Cakes", href: "/photo-cakes" },
                      { label: "Chocolate", href: "/chocolate-cakes" },
                      { label: "Flowers", href: "/flowers" },
                      { label: "Kids Cakes", href: "/kids-cakes" }
                    ].map((sug, i) => (
                      <Link key={i} to={sug.href} className="suggestion-chip" onClick={() => setIsSearchOpen(false)}>
                        {sug.label}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* MOBILE OVERLAY - Only for mobile drawer */}
      {isMenuOpen && <div className="menu-overlay" onClick={() => setIsMenuOpen(false)}></div>}

      {/* MOBILE DRAWER */}
      <div className={`menu-bar ${isMenuOpen ? "open" : ""} mobile-only-drawer`}>
        <div className="drawer-header">
          <img src={logo} alt="Brand Logo" className="drawer-logo" />
          <div className="close-drawer" onClick={() => setIsMenuOpen(false)}>×</div>
        </div>
        <Container fluid>
          <ul className="menu">
            {menuItems.map((item, index) => (
              <li
                key={index}
                className={`nav-item ${openMobileItem === index ? "mobile-open" : ""}`}
              >
                <span
                  className="nav-item-label"
                  onClick={() => toggleMobileItem(index)}
                >
                  {item.label}
                  {item.submenu && (
                    <FaChevronDown className={`nav-chevron ${openMobileItem === index ? "rotated" : ""}`} />
                  )}
                </span>

                {/* Submenu */}
                {item.submenu && (
                  <ul className="dropdown">
                    {item.submenu.map((sub, subIndex) => (
                      <li key={subIndex}>
                        <Link to={sub.href}>{sub.label}</Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </Container>
      </div>

    </header>
  );
};

export default Header;